import type { TranslationTree } from '../../types';

export const backendConfig: TranslationTree = {
  backendConfig: {
    badge: 'Super admin',
    title: 'Configuration backend',
    description:
      "Connexions externes propres à chaque déploiement. Les modifications s'appliquent en direct — sans redémarrage.",
    influx: {
      title: 'InfluxDB',
      description:
        "La base de signaux lue par la page Signaux, les prédictions en direct et le formulaire machine. Le worker de signaux utilise ces identifiants pour des requêtes en lecture seule.",
      savedMessage: 'Le worker de signaux utilisera cette connexion InfluxDB à sa prochaine requête.',
    },
    fields: {
      influxHost: { label: 'Hôte' },
      influxPort: { label: 'Port' },
      influxUser: { label: 'Utilisateur' },
      influxPassword: { label: 'Mot de passe' },
      influxDatabase: { label: 'Base de données' },
    },
    save: 'Enregistrer',
    reset: 'Réinitialiser',
    retry: 'Réessayer',
    saved: 'Configuration enregistrée',
    usingDefaults: {
      title: 'Valeurs par défaut du déploiement',
      body: "Aucune configuration personnalisée n'est encore enregistrée — les champs ci-dessus affichent les valeurs intégrées au .env de ce déploiement. Enregistrer crée une substitution.",
    },
    errors: {
      forbidden: 'Vous devez avoir les droits administrateur pour modifier cette valeur.',
      generic: "Une erreur est survenue lors de l'enregistrement. Veuillez réessayer.",
      loadFailed: 'Impossible de charger la configuration.',
    },
    loading: 'Chargement de la configuration…',
  },
};
